import { AFFAIR_PRIORITIES, AFFAIR_PROJECT_TYPES, AFFAIR_STAGES, canTransitionAffair } from './affairModel';

const STAGE_KEYS = AFFAIR_STAGES.map((stage) => stage.key);
const isBlank = (value) => value === null || value === undefined || String(value).trim() === '';
const isValidDate = (value) => !value || !Number.isNaN(new Date(value).getTime());

export const validateAffair = (affair = {}) => {
  const errors = {};
  if (isBlank(affair.name)) errors.name = 'Le nom de l’affaire est obligatoire.';
  if (isBlank(affair.companyId)) errors.companyId = 'L’entreprise est obligatoire.';
  if (!STAGE_KEYS.includes(affair.stage)) errors.stage = 'L’étape de l’affaire est invalide.';
  if (!AFFAIR_PRIORITIES.includes(affair.priority || 'normal')) errors.priority = 'La priorité est invalide.';

  const probability = Number(affair.probabilityPercent);
  if (!Number.isFinite(probability) || probability < 0 || probability > 100) {
    errors.probabilityPercent = 'La probabilité doit être comprise entre 0 et 100.';
  }

  if (!isBlank(affair.estimatedAmount) && (!Number.isFinite(Number(affair.estimatedAmount)) || Number(affair.estimatedAmount) < 0)) {
    errors.estimatedAmount = 'Le montant estimé doit être positif.';
  }
  if (!isBlank(affair.projectType) && !AFFAIR_PROJECT_TYPES.includes(affair.projectType)) errors.projectType = 'Le type de projet est invalide.';
  if (!isValidDate(affair.responseDeadline)) errors.responseDeadline = 'La date limite de réponse est invalide.';
  return errors;
};

export const validateStageTransition = (affair = {}, transition = {}) => {
  const errors = {};
  const toStage = transition.toStage || transition.stage;
  if (!canTransitionAffair(affair.stage, toStage)) errors.stage = 'Cette transition d’étape n’est pas autorisée.';
  if (['lost', 'abandoned'].includes(toStage) && isBlank(transition.reason || transition.lossReason)) {
    errors.reason = 'Un motif est obligatoire.';
  }
  return errors;
};

export const validateWonAffair = (affair = {}, transition = {}) => {
  const errors = validateStageTransition(affair, { ...transition, toStage: 'won' });
  if (isBlank(transition.acceptedQuoteId)) errors.acceptedQuoteId = 'Un devis accepté est obligatoire.';
  if (isBlank(transition.acceptedAmount) || Number(transition.acceptedAmount) < 0) errors.acceptedAmount = 'Le montant retenu est obligatoire.';
  if (!isValidDate(transition.acceptedAt) || isBlank(transition.acceptedAt)) errors.acceptedAt = 'La date d’acceptation est obligatoire.';
  return errors;
};

export const validateProjectConversion = (affair = {}, payload = {}) => {
  const errors = {};
  if (affair.stage !== 'won') errors.stage = 'Seule une affaire gagnée peut être convertie.';
  if ((affair.realizations || []).length > 0 || (affair.projects || affair.Projects || []).length > 0 || (affair.interventions || affair.Interventions || []).length > 0) errors.project = 'Cette affaire possède déjà une réalisation.';
  if (isBlank(payload.acceptedQuoteId)) errors.acceptedQuoteId = 'Un devis accepté est obligatoire.';
  if (isBlank(affair.companyId || affair.company_id)) errors.companyId = 'Le partenaire est obligatoire.';
  if (isBlank(payload.primaryContactId)) errors.primaryContactId = 'Un contact principal est obligatoire.';
  if (isBlank(payload.project?.name)) errors.projectName = 'Le nom du projet est obligatoire.';
  const nodes = Array.isArray(payload.nodes) ? payload.nodes : [];
  if (nodes.some((node) => isBlank(node.key) || isBlank(node.name))) errors.nodes = 'Chaque nœud doit avoir un nom et une clé.';
  const keys = new Set(nodes.map((node) => node.key));
  if (keys.size !== nodes.length || nodes.some((node) => node.parentKey && !keys.has(node.parentKey))) errors.nodes = 'La hiérarchie des nœuds est invalide.';
  return errors;
};

export const validateInterventionConversion = (affair = {}, payload = {}) => {
  const errors = {};
  if (affair.stage !== 'won') errors.stage = 'Seule une affaire gagnée peut être convertie.';
  if ((affair.realizations || []).length > 0 || (affair.projects || affair.Projects || []).length > 0 || (affair.interventions || affair.Interventions || []).length > 0) errors.intervention = 'Cette affaire possède déjà une réalisation.';
  if (isBlank(payload.acceptedQuoteId)) errors.acceptedQuoteId = 'Un devis accepté est obligatoire.';
  if (isBlank(payload.primaryContactId)) errors.primaryContactId = 'Un contact principal est obligatoire.';
  if (isBlank(payload.intervention?.name)) errors.interventionName = 'Le nom de l’intervention est obligatoire.';
  return errors;
};

export const hasValidationErrors = (errors = {}) => Object.keys(errors).length > 0;
